import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface OrgBillingStatus {
  status: 'free_period' | 'active' | 'grace_ended' | 'past_due' | 'canceled';
  tierKey: string | null;
  tripCap: number | null;
  activeTrips: number;
  freeUntil: string | null;
  daysLeft: number | null;
  canCreateTrip: boolean;
  // Plan picked on the marketing site at signup (intent only — not a billing tier).
  selectedTier?: string | null;
  selectedTrips?: number | null;
}

export interface BillingTier {
  tierKey: string;
  name: string;
  tripCap: number | null;          // null = unlimited
  monthlyPriceCents: number | null;
}

@Injectable({ providedIn: 'root' })
export class OrgBillingService {
  private baseUrl = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getStatus(): Observable<OrgBillingStatus> {
    return this.http.get<OrgBillingStatus>(`${this.baseUrl}/org-billing/status`);
  }
  selectFree(): Observable<OrgBillingStatus> {
    return this.http.post<OrgBillingStatus>(`${this.baseUrl}/org-billing/select-free`, {});
  }
  getTiers(): Observable<BillingTier[]> {
    return this.http.get<BillingTier[]>(`${this.baseUrl}/org-billing/tiers`);
  }
  checkout(tierKey: string): Observable<{ url: string }> {
    return this.http.post<{ url: string }>(`${this.baseUrl}/org-billing/checkout`, { tier_key: tierKey });
  }
  changeTier(tierKey: string): Observable<{ change: 'upgrade' | 'downgrade' | 'same' }> {
    return this.http.post<{ change: 'upgrade' | 'downgrade' | 'same' }>(`${this.baseUrl}/org-billing/change`, { tier_key: tierKey });
  }
  openPortal(): Observable<{ url: string }> {
    return this.http.post<{ url: string }>(`${this.baseUrl}/org-billing/portal`, {});
  }
}
